import React from 'react';
import { BoxDropdownTriggerProps, BoxDropdownTrigger } from './BoxDropdownTrigger';
import { ChipDropdownTrigger, ChipDropdownTriggerProps } from './ChipDropdownTrigger';
import { CustomDropdownTriggerProps, CustomDropdownTrigger } from './CustomDropdownTrigger';
import { CommonTriggerProps } from './types';

type DropdownTriggerProps = CommonTriggerProps &
  (
    | CustomDropdownTriggerProps
    | BoxDropdownTriggerProps
    | ({
        chips: true;
      } & ChipDropdownTriggerProps)
  );

/**
 * The trigger element for a dropdown.  Provides the label / box / caret and
 * expand/collapse behavior on click.
 *
 * @returns
 */
export const DropdownTrigger = (props: DropdownTriggerProps): JSX.Element => {
  if ('chips' in props && props.chips) {
    return <ChipDropdownTrigger {...props} />;
  }
  if ('trigger' in props && props.trigger) {
    return <CustomDropdownTrigger {...props} />;
  }
  return <BoxDropdownTrigger {...props} />;
};
